export default __webpack_public_path__ + "static/media/25.a30abf63.jpg";